import api from "./interceptor";
import axios from "axios";

export const signIn = (formData: any) => {
    let postData = {
        email: formData.username,
        password: formData.password,
    };

    return api.post("/login", postData);
};

export const signUp = (formData: { fname: string, lname: string, email: string, mobile: string, companyname: string, companynumber : string, companyemail : string, companyaddress : string, city : string, password: string, is3cxUse: boolean }) => {
    let postData = {
        firstName: formData.fname,
        lastName: formData.lname,
        mobile: formData.mobile,
        email: formData.email,
        password: formData.password,
        companyName: formData.companyname,
        companyNumber: formData.companynumber,
        companyEmail: formData.companyemail,
        companyAddress: formData.companyaddress,
        city: formData.city,
        is3cxUse : formData.is3cxUse ? 1 : 0
    };

    return api.post("/registration", postData);
};

export const forgotPassord = (formData: { email: string }) => {
    let postData = {
        email: formData.email,
    };

    return api.post("/registration/send-forgot-password-link", postData);
};

export const changePassord = (formData: { token: string, password: string }) => {
    let postData = {
        token: formData.token,
        password: formData.password
    };

    return api.post("/registration/change-user-password", postData);
};

export const verifyAccount = (formData: { token: string}) => {
    let postData = {
        token: formData.token
    };

    return api.post("/registration/complete-verification", postData);
};

export const downloadFile = (url: string) => {
    return axios.get(url, {
        responseType: 'blob',
    });
};

// endponint menu ------>
    // 01 dashboard
    // 02 contact managemnet
    // 03 support pipeline
    // 04 sales pipeline
    // 05 team management
    // 06 employee management
    // 07 package management
    // 08 super admin endpoints
    // 09 dropdown details endpoints

// 01 -------------- dashboard service endpoints starts here -----------------------

export const getDashboardData = () => {
    let postData = null;

    return api.post("/dashboard-management/get-dashboard-details",postData)
}

// 02 -------------- contact service endpoints starts here -----------------------

export const getAllCustomerDetails = (page : number, rowsPerPage : number) => {
    let postData = null;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/customer-management/get-customer-details",postData, {params : params})
}

export const createNewCustomer = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/enter-customer-details",postData)
}

export const updateCustomer = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/update-customer-details",postData)
}

export const searchCustomer = (formData : object, page : number, rowsPerPage : number) => {
    let postData = formData;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/customer-management/search-customer-by-customer-number",postData, {params : params})
}

export const updateAdditionalFields = (formData : object) => {
    let postData = formData;

    return api.post("/contact-form-management/update-contact-form-details",postData)
}

export const getContactFormDetails = () => {
    let postData = null;

    return api.post("/contact-form-management/get-contact-form-details",postData)
}

export const getAllCustomerDetailsWithoutPagination = () => {
    let postData = null;

    return api.post("/customer-management/get-customer-details-without-pagination",postData)
}

export const updateTicket = (formData : object) => {
    let postData = formData;

    return api.post("/ticket-management/update-ticket-details",postData)
}

export const updateSpecificField = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/update-customer-specific-fields",postData)
}

export const getCustomerNote = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/get-customer-notes",postData)
}

export const createCustomerNote = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/add-note-to-customer",postData)
}

export const updateCustomerNote = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/update-customer-note",postData)
}

export const deleteCustomerNote = (formData : object) => {
    let postData = formData;

    return api.post("/customer-management/delete-customer-note",postData)
}

// 03 --------------------- support pipeline service endpoints starts here ----------------------------

export const getPipelineStages = (formData : object) => {
    let postData = formData;

    return api.post("/customer-support-template-management/get-customer-support-stages",postData)
}

export const getPipelineTicket = (formData : object) => {
    let postData = formData;

    return api.post("/customer-support-template-management/get-customer-support-tickets-by-stages",postData)
}

export const changeStagesOrder = (formData : object) => {
    let postData = formData;

    return api.post("/customer-support-template-management/change-stages-order",postData)
}

export const createStage = (formData : object) => {
    let postData = formData;

    return api.post("/stage-management/add-new-stage",postData)
}

export const updateStage = (formData : object) => {
    let postData = formData;

    return api.post("/stage-management/update-stage-details",postData)
}

export const createTicket = (formData : object) => {
    let postData = formData;

    return api.post("/ticket-management/add-new-ticket",postData)
}

export const getFilteredCustomerSupportTickets = (formData : object) => {
    let postData = formData;

    return api.post("/customer-support-template-management/get-filtered-customer-support-tickets-by-stages",postData)
}

export const deleteTicket = (formData : object) => {
    let postData = formData;

    return api.post("/ticket-management/remove-ticket",postData)
}

export const deleteStage = (formData : object) => {
    let postData = formData;

    return api.post("/stage-management/remove-stage",postData)
}


// 04 --------------------- sales pipeline service endpoints starts here ----------------------------

export const getSalesPipelineStages = () => {
    let postData = null;

    return api.post("/sales-support-template-management/get-sales-support-stages",postData)
}

export const getSalesPipelineTicket = (formData : object) => {
    let postData = formData;

    return api.post("/sales-support-template-management/get-sales-support-tickets-by-stages",postData)
}

export const changeSalesPipelineStagesOrder = (formData : object) => {
    let postData = formData;

    return api.post("/sales-support-template-management/change-stages-order",postData)
}

export const createSalesPipelineStage = (formData : object) => {
    let postData = formData;

    return api.post("/stage-management/add-new-stage",postData)
}

export const updateSalesPipelineStage = (formData : object) => {
    let postData = formData;

    return api.post("/stage-management/update-stage-details",postData)
}

export const createSalesPipelineTicket = (formData : object) => {
    let postData = formData;

    return api.post("/ticket-management/add-new-ticket",postData)
}

export const getFilteredSalesPipelineTickets = (formData : object) => {
    let postData = formData;

    return api.post("/sales-support-template-management/get-filtered-sales-support-tickets-by-stages",postData)
}

export const deleteSalesPipelineTicket = (formData : object) => {
    let postData = formData;

    return api.post("/ticket-management/remove-ticket",postData)
}

export const deleteSalesPipelineStage = (formData : object) => {
    let postData = formData;

    return api.post("/stage-management/remove-stage",postData)
}


// 05 ----------------------- team service end points start here ------------------------

export const createTeam = (formData : object) => {
    let postData = formData;

    return api.post("/team-management/add-new-team",postData)
}

export const updateTeam = (formData : object) => {
    let postData = formData;

    return api.post("/team-management/update-team-details",postData)
}

export const getAllTeams = (page : number, rowsPerPage : number) => {
    let postData = null;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/team-management/get-customer-details-with-pagination",postData, {params: params})
}

export const getAllTeamsWithoutPagianation = () => {
    let postData = null;

    return api.post("/team-management/get-team-details-without-pagination",postData)
}

export const getTeamMembers = (formData : object) => {
    let postData = formData;

    return api.post("/team-management/get-team-members",postData)
}

export const searchTeam = (formData : object, page : number, rowsPerPage : number) => {
    let postData = formData;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/team-management/search-team-by-team-name",postData, {params : params})
}

// 06 ----------------------- employee service end points start here ------------------------

export const createEmployee = (formData : object) => {
    let postData = formData;

    return api.post("/user-management/add-new-employee",postData)
}

export const updateEmployee = (formData : object) => {
    let postData = formData;

    return api.post("/user-management/update-employee-details",postData)
}

export const updatePassword = (formData : object) => {
    let postData = formData;

    return api.post("/user-management/update-employee-password",postData)
}

export const getAllEmployees = (page : number, rowsPerPage : number) => {
    let postData = null;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/user-management/get-employee-details-with-pagination",postData, {params: params})
}

export const getAllEmployeesWithoutPagination = () => {
    let postData = null;

    return api.post("/user-management/get-employee-details-without-pagination",postData)
}

export const deleteEmployee = (formData : object) => {
    let postData = formData;

    return api.post("/user-management/delete-employee",postData)
}


export const searchEmployee = (formData : object, page : number, rowsPerPage : number) => {
    let postData = formData;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/user-management/search-employee-by-email",postData, {params : params})
}


// 07 ----------------------- package service end points start here ------------------------

export const getPackagesForUsers = (page: number, rowsPerPage:number) => {
    let params = {
        page: page,
        size: rowsPerPage
    }
    let postData = null;
    
    return api.post("/package-management/get-all-packages-list-for-users",postData, {params:params})
}

export const selectPackages = (formData : object) => {
    let postData = formData;

    return api.post("/company-package-management/select-package-for-company",postData)
}

export const changePackage = (formData : object) => {
    let postData = formData;

    return api.post("/company-package-management/update-company-package",postData)
}


// 08 ----------------------- super admin service end points start here ------------------------

export const getPackagesforSuperAdmin = (page : number, rowsPerPage : number) => {
    let postData = null;
    let params = {
        page : page,
        size : rowsPerPage
    }
    
    return api.post("/package-management/get-all-packages-list",postData,{params : params})
}

export const createPackage = (formData : object) => {
    let postData = formData;

    return api.post("/package-management/add-new-package",postData)
}

export const updatePackage = (formData : object) => {
    let postData = formData;
    
    return api.post("/package-management/update-package-details",postData)
}

export const getCompaniesforSuperAdmin = (page : number, rowsPerPage : number) => {
    let postData = null;
    let params = {
        page : page,
        size : rowsPerPage
    }

    return api.post("/super-admin/get-all-company-list",postData,{params : params})
}

export const changeCompanyStatusforSuperAdmin = (formData : object) => {
    let postData = formData;

    return api.post("/super-admin/change-company-status",postData)
}

export const searchPackage = (formData : object, page : number, rowsPerPage : number) => {
    let postData = formData;
    let params = {
        page : page,
        size : rowsPerPage
    }
    
    return api.post("/package-management/search-package-by-package-name",postData, {params : params})
}


// 09 ----------------------- dropdown details service end points start here ------------------------


export const getPipelineDropdownDetails = () => {
    
    return api.post("/dropdown-details-management/get-company-customer-list")
}